import { imageUrl } from '../format';

interface Props {
  imageId: string | null | undefined;
  alt?: string;
  /** "blank" is the quiet placeholder for small thumbnails. */
  empty?: 'hatch' | 'blank';
}

export function CanImage({ imageId, alt = '', empty = 'hatch' }: Props) {
  if (!imageId) {
    return <div className={`can-img can-img--${empty === 'hatch' ? 'empty' : 'blank'}`} aria-hidden="true" />;
  }
  return <img className="can-img" src={imageUrl(imageId)} alt={alt} loading="lazy" decoding="async" draggable={false} />;
}
